module.exports = __webpack_public_path__ + "static/media/galaxy.2f158342.svg";